<template>
    <nav class="timeline-nav-mobile">
      <ul>
        <li v-for="decade in decades" :key="decade" :class="{'selected': selectedDecade === decade}">
          <a :href="'#' + decade + 's'" @click.prevent="selectDecade(decade)"><span>{{decade + 's'}}</span></a>
        </li>
      </ul>
    </nav>
  </template>
  
  <script>
    import { mapActions, mapGetters } from 'vuex';
  
    export default {
      computed: {
        ...mapGetters(['decades', 'selectedDecade']),
      },
      methods: {
        ...mapActions(['selectDecade']),
      }
    };
</script>
  


// WEBPACK FOOTER //
// MobileNav.vue?9c10ad4a